import { factory } from '@wix/web-bi-logger';
import { type PageType } from '@wix/cashier-common/dist/src/enums/PageType';
import { isMonitoringEnabled } from './isMonitoringEnabled';

export interface DefaultBIParams {
  appId: string;
  appInstanceId: string;
  orderSnapshotId: string;
  mobileAppId: string;
  mobileAppVersion: string;
  visitorId: string;
  msid: string;
  checkoutSessionId: string;
  appSessionId: string;
  pageType: PageType;
}

const biLoggerFactory = factory({
  // by default bi logger emits "page view" event at this point (mute happens next, thus has no effect on this event)
  trackSession: isMonitoringEnabled(),
});

biLoggerFactory.setMuted(!isMonitoringEnabled());

export const updateBILoggerDefaults = (defaults: Partial<DefaultBIParams>) => biLoggerFactory.updateDefaults(defaults);

export const biLogger = biLoggerFactory.logger();
